import { tick } from "svelte";
import { init } from "svelte/internal";
export const FOCUSABLE_ELEMENTS = [
  "a[href]",
  "area[href]",
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  "select:not([disabled]):not([aria-hidden])",
  "textarea:not([disabled]):not([aria-hidden])",
  "button:not([disabled]):not([aria-hidden])",
  "iframe",
  "object",
  "embed",
  "[contenteditable]",
  '[tabindex]:not([tabindex^="-"])', // Include elements with positive tabindex
];

export function focusTrap(
  node,
  { focusableSelectors = FOCUSABLE_ELEMENTS.join(",") } = {}
) {
  let firstFocusableElement;
  let lastFocusableElement;
  let focusableElements;

  async function initializeFocusTrap() {
    await tick();
    const observer = new MutationObserver(() => {
      updateFocusableElements();
    });

    observer.observe(node, { childList: true, subtree: true });
    updateFocusableElements();
  }

  function updateFocusableElements() {
    // Get all focusable elements and filter out the ones that are disabled or hidden
    focusableElements = Array.from(
      node.querySelectorAll(focusableSelectors)
    ).filter(
      (el) => !el.hasAttribute("disabled") && !el.hasAttribute("aria-hidden")
    );

    console.log(focusableElements);

    // Respect tabindex order
    focusableElements.sort((a, b) => {
      let aIndex = a.hasAttribute("tabindex")
        ? parseInt(a.getAttribute("tabindex"))
        : 0;
      let bIndex = b.hasAttribute("tabindex")
        ? parseInt(b.getAttribute("tabindex"))
        : 0;
      return aIndex - bIndex;
    });

    console.log("after sort", focusableElements);
    // Set first and last focusable elements
    firstFocusableElement = focusableElements[0];
    lastFocusableElement = focusableElements[focusableElements.length - 1];
  }

  function handleKeyDown(event) {
    if (event.key !== "Tab") return;

    event.preventDefault();
    const index = focusableElements.indexOf(document.activeElement);
    const isBackward = event.shiftKey;

    if (index === -1) {
      firstFocusableElement.focus();
      return;
    }

    const nextIndex = isBackward
      ? (index - 1 + focusableElements.length) % focusableElements.length
      : (index + 1) % focusableElements.length;

    focusableElements[nextIndex].focus();
  }

  initializeFocusTrap();
  node.addEventListener("keydown", handleKeyDown);
  return {
    update(newOptions) {
      if (
        newOptions.focusableSelectors &&
        newOptions.focusableSelectors !== focusableSelectors
      ) {
        focusableSelectors = newOptions.focusableSelectors;
        updateFocusableElements();
      }
    },
    destroy() {
      node.removeEventListener("keydown", handleKeyDown);
    },
  };
}
